module.exports = __webpack_public_path__ + "static/media/6.19.6bf0eea1.png";